import React from "react"
import tw from "twin.macro"
import Icon from "../Icon"

const AnimatedIcon: React.FC<{ isExpanded: boolean }> = ({ isExpanded }) => {
  return (
    <div css={[tw`flex items-center justify-center relative h-4 w-4`]}>
      <span
        css={[
          tw`absolute w-4 h-4 text-center origin-center transition-all duration-500 ease-in-out	box-content`,
          isExpanded ? tw`opacity-100 rotate-0` : tw`opacity-0 scale-y-0`,
        ]}
      >
        <Icon.Chevron direction="up" css={[tw`text-black w-4`]} />
      </span>
      <span
        css={[
          tw`absolute w-4 h-4 text-center origin-center transition-all	duration-500 ease-in-out box-content p-1`,
          isExpanded ? tw`opacity-0 rotate-0` : tw`opacity-100 scale-y-[-1]`,
        ]}
      >
        <Icon.Chevron direction="up" css={[tw`text-black w-4`]} />
      </span>
    </div>
  )
}

export default AnimatedIcon
